'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.default = country;

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _country = require('../actions/country');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getCountries),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getCountryList),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(fetchCountries),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(country);

function getCountries() {
  var apiObj, res;
  return _regenerator2.default.wrap(function getCountries$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          apiObj = new _webUtils.API();
          _context.next = 4;
          return apiObj.get(_webUtils.Urls.country.getAllCountries, undefined, true);

        case 4:
          res = _context.sent;

          if (!_webUtils.STATUS.isSuccess(res.status)) {
            _context.next = 10;
            break;
          }

          _context.next = 8;
          return (0, _effects.put)({ type: _country.COUNTRY.LOAD_DONE, countries: res.data });

        case 8:
          _context.next = 12;
          break;

        case 10:
          _context.next = 12;
          return (0, _effects.put)({ type: _country.COUNTRY.LOAD_FAIL });

        case 12:
          _context.next = 18;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context['catch'](0);
          _context.next = 18;
          return (0, _effects.put)({ type: _country.COUNTRY.LOAD_FAIL });

        case 18:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 14]]);
}
function getCountryList() {
  var apiObj, res;
  return _regenerator2.default.wrap(function getCountryList$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          apiObj = new _webUtils.API();
          _context2.next = 4;
          return apiObj.get(_webUtils.Urls.country.getCountryCodes, undefined, true);

        case 4:
          res = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(res.status)) {
            _context2.next = 10;
            break;
          }

          _context2.next = 8;
          return (0, _effects.put)({ type: _country.COUNTRY.LOAD_LIST_DONE, countries: res.data });

        case 8:
          _context2.next = 12;
          break;

        case 10:
          _context2.next = 12;
          return (0, _effects.put)({ type: _country.COUNTRY.LOAD_LIST_FAIL });

        case 12:
          _context2.next = 18;
          break;

        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 18;
          return (0, _effects.put)({ type: _country.COUNTRY.LOAD_LIST_FAIL });

        case 18:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 14]]);
}

function fetchCountries() {
  var api, response;
  return _regenerator2.default.wrap(function fetchCountries$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          api = new _webUtils.API();
          _context3.next = 3;
          return api.get(_webUtils.Urls.country.getCountries, undefined, true);

        case 3:
          response = _context3.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context3.next = 9;
            break;
          }

          _context3.next = 7;
          return (0, _effects.put)((0, _country.loadCountriesSuccess)(response.data));

        case 7:
          _context3.next = 11;
          break;

        case 9:
          _context3.next = 11;
          return (0, _effects.put)((0, _country.loadCountriesFailed)());

        case 11:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function country() {
  return _regenerator2.default.wrap(function country$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeEvery)(_country.COUNTRY.LOAD, getCountries);

        case 2:
          _context4.next = 4;
          return (0, _effects.takeEvery)(_country.COUNTRY.LOAD_LIST, getCountryList);

        case 4:
          _context4.next = 6;
          return (0, _effects.takeEvery)(_country.COUNTRIES.COUNTRIES.LOADING, fetchCountries);

        case 6:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}
module.exports = exports['default'];